import { createAction } from 'redux-act';
import { logging } from 'gandi.redux-logger';
import sharingResource from './resource';
import { selectCurrentId, selectPersonalId } from './selectors';
const logger = dispatch => logging(dispatch, 'gandi.sharing/modules/actions');
export const setCurrentId = createAction('Set current organization id');
export const setPersonalId = createAction('Set personal organization id');
export const fetchOrganizations = (query, accumulate = false) => dispatch => {
  const baseUrl = '/organization/organizations';
  const url = query ? `${baseUrl}?${query}` : baseUrl;
  return dispatch(sharingResource.fetch(url, {
    label: query ? 'filtered' : undefined,
    accumulate
  }));
};
export const fetchOrganizationsWithSubset = (query, accumulate = false) => (dispatch, getState) => {
  const personalId = selectPersonalId(getState());
  const baseUrl = personalId ? `/organization/users/${personalId}/projects` : '/organization/organizations';
  const url = query ? `${baseUrl}?${query}` : baseUrl;
  if (!personalId) {
    dispatch(logger).warn(`No personalId. Fallback to route ${url}`);
  }
  return dispatch(sharingResource.fetch(url, {
    label: query ? 'filtered' : undefined,
    accumulate
  }));
};
export const fetchOneOrganization = id => dispatch => dispatch(sharingResource.fetchOne(`/organization/organizations/${id}`, {
  label: id
}));
export const fetchPersonal = () => (dispatch, getState) => {
  const personalId = selectPersonalId(getState());
  dispatch(logger).info(`Fetching personal organization: ${personalId}`);
  return dispatch(fetchOneOrganization(personalId));
};
export const fetchCurrentSharing = (sharingId_, hasSubsetOrgSupport = false) => (dispatch, getState) => {
  const sharingId = sharingId_ || selectCurrentId(getState());
  dispatch(logger).info(`Fetching current organization: ${sharingId}`);
  if (!hasSubsetOrgSupport) {
    return dispatch(fetchOneOrganization(sharingId)).then(response => {
      dispatch(setCurrentId(sharingId));
      return response;
    });
  }
  const personalId = selectPersonalId(getState());
  if (!personalId) {
    return Promise.reject(new Error('Undefined personal id! ' + "Reducer didn't handle the setPersonalId action?"));
  }
  dispatch(logger).info(`Fetching subset organization ${sharingId} for user ${personalId}`);
  return dispatch(sharingResource.fetchOne(`/organization/users/${personalId}/projects/${sharingId}`, {
    label: sharingId
  })).then(response => {
    dispatch(setCurrentId(sharingId));
    if (response.data.subset) {
      return response;
    }
    return dispatch(fetchOneOrganization(sharingId));
  });
};
export const fetchCurrentSharingAndSetPersonal = (sharingId, req, hasSubsetOrgSupport = false) => (dispatch, getState) => {
  dispatch(logger).debug({
    tokeninfo: req.tokeninfo
  }, 'Setting Personal org with tokeninfo data ...');
  if (!sharingId) {
    sharingId = selectCurrentId(getState());
  }
  dispatch(setPersonalId(req.tokeninfo.user_id));
  if (sharingId === req.tokeninfo.user_id) {
    return dispatch(fetchCurrentSharing(sharingId, hasSubsetOrgSupport));
  }
  return dispatch(fetchPersonal()).then(() => dispatch(fetchCurrentSharing(sharingId, hasSubsetOrgSupport)));
};